import axios from "axios";
import React, { useEffect, useState } from "react";
import CMSWorkingHourTable from "./CMSWorkingHourTable";
import Loading from "../../Extra/Loading";
import CMSWorkingHourFilter from "./CMSWorkingHourFilter";
import { getCurrentFY } from "../../Utilitie";
import WorkingHoursGraph from "./WorkingHoursGraph";
import GaugeComponentInput from "../../CHARTS/GaugeComponentInput";
import CMSLobbyWorkingHourTable from "./CMSLobbyWorkingHourTable";
import CMSMonthWorkingHourTable from "./CMSMonthWorkingHourTable";
import CMSLobbyGraph from "./CMSLobbyGraph";
import CMSKpiCards from "./CMSKpiCards";
const opState = {
  Year: false,
  Month: false,
  Lobby: false,
};
const tablets = ["All", "Month Wise", "Lobby Wise"];
const CrewWorkingHourMaster = () => {
  const [filteredData, setFilteredData] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [fetchedData, setFetchedData] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [CMSFilteredData, setCMSFilteredData] = useState(null);
  const urlPrefixBlock = process.env.REACT_APP_URL_CMS_PREFIX;
  const [loading, setLoading] = useState(false);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(getCurrentFY().slice(0, 4));
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // last 10 years
  const [activePage, setActivePage] = useState("All");
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}cms_working_hr?cms_year=${year}`,
      );
      if (response.data.status === "ok") {
        setLoading(false);
        setFetchedData(response.data);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [year]);

  return (
    <div
      onClick={() => {
        setOpenStates(opState);
      }}
    >
      <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
        <div>
          <h5 className="">Crew Working Hour Report{}</h5>
        </div>
        <div className="row pe-3 d-flex align-items-center">
          <b className="col-md text-end" style={{ fontSize: "18px" }}>
            Year
          </b>
          <div className="col-md">
            <select
              style={{ width: "100px", height: "35px" }}
              className="form-select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">--FY-- </option>
              {years.map((yr, i) => (
                <option key={yr} value={yr}>
                  {yr}-{String(yr + 1).slice(2, 4)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {loading && <Loading />}

      {fetchedData?.current_data && (
        <div>
          <div className="sticky-controller ">
            <CMSWorkingHourFilter
              data={fetchedData?.current_data}
              setSelectedFilters={setSelectedFilters}
              setFilteredData={setFilteredData}
              openStates={openStates}
              setOpenStates={setOpenStates}
            />
          </div>
          {filteredData?.length > 0 && (
            <CMSKpiCards
              data={filteredData}
              selectedFilters={selectedFilters}
            />
          )}
          <div className="row">
            <div className="col-md-6">
              {filteredData?.length > 0 && (
                <div>
                  <WorkingHoursGraph
                    data={filteredData}
                    selectedFilters={selectedFilters}
                  />
                  <CMSLobbyGraph
                    data={filteredData}
                    selectedFilters={selectedFilters}
                  />
                </div>
              )}{" "}
            </div>
            <div className="col-md-6 newUiBody">
              <div className="row ">
                <div className="  ">
                  <div className="d-flex justify-content-center">
                    {tablets.map((table, i) => {
                      return (
                        <button
                          onClick={() => {
                            setActivePage(table);
                          }}
                          key={i}
                          className={`btn m-1 btn-sm btn-outline-dark ${
                            table === activePage && "active"
                          }`}
                        >
                          {table}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-12">
                  {" "}
                  {activePage === "All" && (
                    <CMSWorkingHourTable data={filteredData} />
                  )}{" "}
                  {activePage === "Month Wise" && (
                    <CMSMonthWorkingHourTable data={filteredData} />
                  )}
                  {activePage === "Lobby Wise" && (
                    <CMSLobbyWorkingHourTable data={filteredData} />
                  )}
                </div>
              </div>
            </div>
            {filteredData?.length > 0 && <div className="col-md-6"></div>}
          </div>

          <hr />
        </div>
      )}
    </div>
  );
};

export default CrewWorkingHourMaster;
